import { Typography } from 'shared/components/Typography';

export const PlanningTitle = () => (
  <Typography
    as="h2"
    type="semiLargeHeading"
    color="black"
    fontWeight="semibold"
  >
    Sprint planning
  </Typography>
);
